import React, { useEffect } from 'react';
import settingServiceActions from 'features/settingService/services/actions';
import { useAppDispatch } from 'store/hooks';
import DiscountPercentage from './components/DiscountPercentage';

type IDiscountProps = {};
const Discount: React.FC<IDiscountProps> = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(settingServiceActions.getSpecialDiscount.fetch());
  }, []);

  return <DiscountPercentage />;
};

export default Discount;
